/** What a share did: the system share sheet took it, it was copied, or the person cancelled. */
export type ShareOutcome = "shared" | "copied" | "cancelled";

/** Where the control that started a share is, in CSS pixels from the top left of the window. */
export type ShareAnchor = { x: number; y: number; width: number; height: number };

/** Extras for a share. The desktop share menu opens next to `from` and gives Mail the title. */
export type ShareOptions = { title?: string; from?: ShareAnchor };

/** An entry from the phone's address book. */
export type AddressBookEntry = { name: string; phones: string[] };

/** Whether this browser has a share sheet. Most desktop browsers do not. */
export function webHasShareSheet(): boolean {
  return typeof globalThis.navigator?.share === "function";
}

/**
 * Shares text and a link through the browser's share sheet where there is one. Elsewhere, such as
 * most desktop browsers, it copies them so the person can paste them into another app.
 */
export async function webShare(text: string, url?: string): Promise<ShareOutcome> {
  const nav = globalThis.navigator as Navigator | undefined;
  if (nav?.share) {
    try {
      await nav.share(url ? { text, url } : { text });
      return "shared";
    } catch (err) {
      if ((err as Error).name === "AbortError") return "cancelled";
    }
  }
  const full = url && !text.includes(url) ? `${text} ${url}` : text;
  await nav?.clipboard?.writeText(full);
  return "copied";
}
